"use client";
import { useSessionStorage } from "usehooks-ts";
import { env } from "../setup/env";
import { getCookie } from "../utils/cookies";

const SESSION_STORAGE_KEY = "jobPipelineReferrer";

/**
 * @returns state for sessionStorage of jobPipelineReferrer
 */
export function useReferrerStorage() {
  return useSessionStorage(SESSION_STORAGE_KEY, "");
}

/**
 *
 * @param referrer – https://google.com
 * @param gaId – the GA.ID form cookies
 * @returns <referrer>(gaId)
 */
export function constructJobPipelineValue({
  gaId,
  referrer,
}: {
  referrer?: string;
  gaId: string | null;
}) {
  if (!gaId) {
    return referrer || "Jobboard";
  }
  return `${referrer}(${gaId})`;
}

export function sanitizeUrl(url: string) {
  if (url.startsWith("http://") || url.startsWith("https://")) {
    return new URL(url);
  }

  return new URL(`${env.NEXT_PUBLIC_BASE_URL}${url}`);
}

/**
 *
 * @param url the applicationUrl e.g. https://edri.jobs.personio.com/job/1183614?display=en#apply
 * @param addGaID
 * @returns
 */
export function useJobPipeline() {
  const [referrer] = useReferrerStorage();

  async function addParam(url: string, addGaID?: boolean) {
    const newApplicationUrl = sanitizeUrl(url);
    const gaId = addGaID ? await getCookie("_ga") : null;
    const value = constructJobPipelineValue({ referrer, gaId });

    newApplicationUrl.searchParams.set("jobPipeline", value);

    return decodeURIComponent(newApplicationUrl.toString());
  }

  return { addParam };
}
